import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      "max-width": "500",
      "persistent": ""
    },
    model: {
      value: _vm.internalOpen,
      callback: function ($$v) {
        _vm.internalOpen = $$v;
      },
      expression: "internalOpen"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    class: `headline ${_vm.color}--text`
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.disable.title')) + "\n    ")]), _c(VCardText, {
    staticClass: "pt-4"
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.disable.message')))]), _c(VRadioGroup, {
    model: {
      value: _vm.selectedOption,
      callback: function ($$v) {
        _vm.selectedOption = $$v;
      },
      expression: "selectedOption"
    }
  }, [_c(VRadio, {
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.dialogs.disable.optionDisable'),
      "value": "disable",
      "color": _vm.color
    }
  }), _c(VRadio, {
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.dialogs.disable.optionDelete'),
      "value": "delete",
      "color": _vm.color
    }
  })], 1)], 1), _c(VDivider), _c(VCardActions, [_c(VSpacer), _c(VBtn, {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.disable.cancel')) + "\n      ")]), _c(VBtn, {
    attrs: {
      "color": _vm.selectedOption === 'delete' ? 'red' : _vm.color
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.disable.confirm')) + "\n      ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };